import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import ResendVerification from '../../components/auth/ResendVerification';

export default function VerifyEmailPage() {
  const { state } = useLocation();
  // Arrives from signup with the address in router state. Opened any other way
  // (a bookmark, a pasted link) there is none, so ask for it instead of
  // offering a Send button that has nowhere to send.
  const knownEmail = state?.email || '';
  const [typedEmail, setTypedEmail] = useState('');
  const email = knownEmail || typedEmail.trim();

  return (
    <div style={{ minHeight: '100vh', background: 'var(--brand-paper)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 'var(--space-xxl)', fontFamily: 'var(--font-ui)' }}>
      <div style={{ width: '100%', maxWidth: 420, textAlign: 'center' }}>

        <div style={{ textAlign: 'center', marginBottom: 'var(--space-h3)' }}>
                <Link to="/" style={{ textDecoration: 'none' }}>
                 <div style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', gap: 'var(--space-xs)' }}>
                  <img src="/logo2.png" alt="Reanlo" style={{ width: 160, height: 48, objectFit: 'cover'}} />
                  <p style={{ fontSize: 'var(--font-size-base)', color: 'var(--neutral-400)', margin: 'var(--space-none)' }}>Reading beyond the Algorithm</p>
                </div>
                </Link>
              </div>

        <div style={{ background: 'var(--brand-white)', borderRadius: 'var(--radius-xxl)', padding: '40px 32px', border: '1px solid var(--brand-sand)', boxShadow: '0 4px 24px rgba(0,0,0,0.06)' }}>
          <span style={{ fontSize: 'var(--font-size-mega)', display: 'block', marginBottom: 'var(--space-xl)' }}>✉️</span>
          <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'var(--font-size-h4)', fontWeight: 700, color: 'var(--neutral-800)', margin: '0 0 12px' }}>Check your email</h2>
          <p style={{ fontSize: 'var(--font-size-md)', color: 'var(--neutral-500)', margin: '0 0 6px', lineHeight: 1.6 }}>
            We sent a confirmation link to
          </p>
          <p style={{ fontSize: 15, fontWeight: 700, color: 'var(--neutral-800)', margin: '0 0 24px' }}>{knownEmail || 'your email'}</p>
          <p style={{ fontSize: 'var(--font-size-base)', color: 'var(--neutral-400)', margin: '0 0 32px', lineHeight: 1.6 }}>
            Click the link in the email to activate your account. Check your spam folder if you don't see it.
          </p>

          {!knownEmail && (
            <input
              type="email" value={typedEmail} onChange={e => setTypedEmail(e.target.value)}
              placeholder="Your email address" aria-label="Your email address"
              style={{ width: '100%', padding: '11px 14px', borderRadius: 'var(--radius-10)', border: '1px solid var(--brand-sand)', fontSize: 'var(--font-size-md)', color: 'var(--neutral-800)', outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit', background: 'var(--brand-paper)', marginBottom: 'var(--space-md)' }}
            />
          )}
          <ResendVerification key={email} email={email} />

          {/* Parchment-style tip card */}
          <div style={{ background: '#fffbeb', border: '1px solid var(--feedback-warning-border)', borderRadius: 'var(--radius-lg)', padding: '14px 18px', marginBottom: 'var(--space-xxl)', textAlign: 'left' }}>
            <p style={{ fontSize: 'var(--font-size-sm)', color: 'var(--feedback-warning-ink)', margin: 'var(--space-none)', lineHeight: 1.6 }}>
              <strong>Reanlo is what happens when you let readers and authors,</strong> not algorithms or marketing budgets, decide how book gets discovered.
            </p>
          </div>

          <Link
            to="/login"
            style={{ fontSize: 'var(--font-size-base)', color: 'var(--feedback-warning)', fontWeight: 600, textDecoration: 'none' }}
          >
            Already confirmed? Log in →
          </Link>
        </div>
      </div>
    </div>
  );
}
